import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Truncate from 'react-truncate';
import {Interactive} from "react-interactive";
import "./ReadMore.scss";

class ReadMore extends Component {
    constructor(...args) {
        super(...args);

        this.state = {
            expanded: false,
            truncated: false
        };
    }

    handleTruncate = (truncated) => {
        if (this.state.truncated !== truncated) {
            this.setState({
                truncated
            });
        }
    }

    toggleLines = (event) => {
        event.preventDefault();

        this.setState({
            expanded: !this.state.expanded
        });
    }

    render() {
        const {
            children,
            more,
            less,
            lines,
            transcripts
        } = this.props;

        const {
            expanded,
            truncated
        } = this.state;

        return (
            <div className="tvp-video-description">
                <Truncate
                    lines={!expanded && lines}
                    trimWhitespace={true}
                    onTruncate={this.handleTruncate}
                >
                    {children}
                </Truncate>
                {(transcripts && expanded) && <div className={"transcript"}>
                    <h3 className={"transcript-title"}>
                        Transcript
                    </h3>
                    <div className={"transcript-content"}>
                        {transcripts}
                    </div>
                </div>}
                <div className="tvp-show-more text-left">
                    {!truncated && expanded && (
                        <Interactive as="button" className="clamp-lines__button" normal={{className: "tvp-normal"}}
                                     hover={{className: "tvp-hovered"}}
                                     onClick={this.toggleLines}>{less}</Interactive>
                    )}
                    {truncated && !expanded && (
                        <Interactive as="button" className="clamp-lines__button" normal={{className: "tvp-normal"}}
                                     hover={{className: "tvp-hovered"}}
                                     onClick={this.toggleLines}>{more}</Interactive>
                    )}
                </div>
            </div>
        );
    }
}

ReadMore.defaultProps = {
    lines: 3,
    more: 'Show More',
    less: 'Show Less',
    transcripts: ""
};

ReadMore.propTypes = {
    children: PropTypes.node.isRequired,
    lines: PropTypes.number,
    less: PropTypes.string,
    more: PropTypes.string,
    transcripts: PropTypes.string
};

export default ReadMore;